// extracted by mini-css-extract-plugin
export default {"bookNowBtn":"BookNowBtn_bookNowBtn__1ojo6","button":"BookNowBtn_button__RviJn"};